import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextCaptionProps = Pick<
  TypographyProps,
  | 'label'
  | 'color'
  | 'ellipsis'
  | 'uppercase'
  | 'lineHeight'
  | 'tagName'
  | 'underline'
  | 'role'
  | 'fontWeight'
  | 'newLineBreak'
>;

export const TextCaption = ({
  label,
  color = 'text-ds-natural',
  lineHeight = 'leading-ds-200',
  ellipsis,
  uppercase,
  underline,
  fontWeight = 'font-ds-light',
  ...rest
}: TextCaptionProps) => (
  <Typography
    ellipsis={ellipsis}
    uppercase={uppercase}
    underline={underline}
    color={color}
    label={label}
    lineHeight={lineHeight}
    tagName="span"
    fontSize="text-ds-200"
    fontWeight={fontWeight}
    letterSpacing="tracking-ds-tight"
    {...rest}
  />
);
